<div class="modal-header">
  <h4 class="modal-title" translate>Premium Presets</h4>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <!-- Premium not enabled warning -->
  <div *ngIf="!isPremiumEnabled" class="alert alert-warning" role="alert">
    <span translate>scaleImageConfigurator.premiumDisabledMessage</span>
  </div>

  <div *ngIf="isLoading" class="text-center py-4">
    <span translate>Loading...</span>
  </div>

  <div *ngIf="!isLoading && isPremiumEnabled" class="premium-container">
    <!-- Presets List -->
    <div class="presets-section">
      <h5 translate>Select Preset</h5>
      <div class="preset-search">
        <input
          type="text"
          class="form-control"
          [(ngModel)]="presetSearchQuery"
          (input)="filterPresets()"
          placeholder="{{ 'Search presets...' | translate }}"
        />
      </div>
      <div class="presets-list">
        <div
          *ngFor="let preset of filteredPresets"
          class="preset-item"
          [class.active]="selectedPreset?.id === preset.id"
          (click)="selectPreset(preset)"
        >
          {{ preset.name }}
        </div>
        <div *ngIf="filteredPresets.length === 0" class="no-data" translate>
          No presets available
        </div>
      </div>
    </div>

    <!-- Targets List -->
    <div *ngIf="selectedPreset" class="targets-section">
      <div class="targets-header">
        <h5>{{ selectedPreset.name }} - Targets</h5>
        <div class="bulk-actions">
          <div class="choose-window">
            <p translate>global.off</p>
            <label class="switch">
              <input type="checkbox" [checked]="areAllSelected" (change)="toggleAll()">
              <span class="slider round"></span>
            </label>
            <p translate>global.on</p>
          </div>
        </div>
      </div>

      <div class="targets-list">
        <div
          *ngFor="let target of selectedPreset.targets"
          class="target-item"
        >
          <label class="target-label">
            <input
              type="checkbox"
              [checked]="target.usePremium"
              (change)="toggleTargetPremium(target)"
            />
            <img
              *ngIf="target.thumbnailPath"
              [src]="target.thumbnailPath"
              alt="Position {{ target.position }}"
              class="target-thumbnail"
            />
            <div *ngIf="!target.thumbnailPath" class="target-thumbnail-placeholder"></div>
            <span>Position: {{ target.position }}</span>
          </label>
        </div>
        <div *ngIf="selectedPreset.targets.length === 0" class="no-data" translate>
          No targets available
        </div>
      </div>
    </div>

    <div *ngIf="!selectedPreset" class="no-selection">
      <p translate>Select a preset to manage premium targets</p>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-secondary"
    (click)="close()"
    translate
  >global.cancel</button>
  <button
    *ngIf="isPremiumEnabled"
    type="button"
    class="btn btn-primary"
    [disabled]="!selectedPreset || isSaving"
    (click)="save()"
  >
    <span *ngIf="!isSaving" translate>global.save</span>
    <span *ngIf="isSaving" translate>Saving...</span>
  </button>
</div>
